import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import AuthApiError from '../errors/AuthApiError.js';
import AuthSdkError from '../errors/AuthSdkError.js';
import OAuthError from '../errors/OAuthError.js';
import WWWAuthError from '../errors/WWWAuthError.js';
import { httpRequest } from '../http/request.js';
import 'tiny-emitter';
import 'js-cookie';
import 'cross-fetch';
import { isAccessToken, isIDToken } from './types/Token.js';
function getUserInfo(_x, _x2, _x3) {
  return _getUserInfo.apply(this, arguments);
}
function _getUserInfo() {
  _getUserInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(sdk, accessTokenObject, idTokenObject) {
    var options, headers;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (accessTokenObject) {
            _context.next = 4;
            break;
          }
          _context.next = 3;
          return sdk.tokenManager.getTokens();
        case 3:
          accessTokenObject = _context.sent.accessToken;
        case 4:
          if (idTokenObject) {
            _context.next = 8;
            break;
          }
          _context.next = 7;
          return sdk.tokenManager.getTokens();
        case 7:
          idTokenObject = _context.sent.idToken;
        case 8:
          if (!(!accessTokenObject || !isAccessToken(accessTokenObject))) {
            _context.next = 10;
            break;
          }
          return _context.abrupt("return", Promise.reject(new AuthSdkError('getUserInfo requires an access token object')));
        case 10:
          if (!(!idTokenObject || !isIDToken(idTokenObject))) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", Promise.reject(new AuthSdkError('getUserInfo requires an ID token object')));
        case 12:
          options = {
            url: accessTokenObject.userinfoUrl,
            method: 'GET',
            accessToken: accessTokenObject.accessToken
          };
          if (!sdk.options.dpop) {
            _context.next = 19;
            break;
          }
          _context.next = 16;
          return sdk.getDPoPAuthorizationHeaders(Object.assign(Object.assign({}, options), {
            accessToken: accessTokenObject
          }));
        case 16:
          headers = _context.sent;
          options.headers = headers;
          delete options.accessToken;
        case 19:
          return _context.abrupt("return", httpRequest(sdk, options).then(function (userInfo) {
            if (userInfo.sub === idTokenObject.claims.sub) {
              return userInfo;
            }
            return Promise.reject(new AuthSdkError('getUserInfo request was rejected due to token mismatch'));
          }).catch(function (err) {
            var _a;
            if (err instanceof WWWAuthError && !sdk.options.dpop) {
              var error = err.error,
                errorDescription = err.errorDescription;
              throw new OAuthError(error, errorDescription);
            }
            if (!sdk.options.dpop) {
              var e = err;
              if (err instanceof AuthApiError && ((_a = err === null || err === void 0 ? void 0 : err.meta) === null || _a === void 0 ? void 0 : _a.wwwAuthHeader)) {
                e = WWWAuthError.parseHeader(err.meta.wwwAuthHeader);
              }
              if (e instanceof WWWAuthError) {
                var _e = e,
                  _error = _e.error,
                  _errorDescription = _e.errorDescription;
                throw new OAuthError(_error, _errorDescription);
              }
            }
            throw err;
          }));
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getUserInfo.apply(this, arguments);
}
export { getUserInfo };